// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__ks_8g"};